// components/DataTable/DataTableEditForm.jsx

import React, { useRef } from "react";
import {
  Form,
  Button,
  Spinner
} from "react-bootstrap";

import {
  findDropdownItem
} from "./utils";
import { CheckLg } from "react-bootstrap-icons";

/**
 * @typedef {Object} DataTableEditFormProps
 * @property {Object} row
 * @property {Array<Object>} columns
 * @property {Object} errors
 * @property {function(Object, Object, *): void} onChange
 * @property {function(): void} onSave
 * @property {function(): void} onCancel
 * @property {boolean} saving
 * @property {boolean} showButtons
 */

/**
 * @param {DataTableEditFormProps} props
 */
function DataTableEditForm({
  row,
  columns,
  errors,
  onChange,
  onSave,
  onCancel,
  saving,
  showButtons,
  autoFocus: extAutoFocus = false
}) {
  /**
   * @param {Object} column
   * @returns {JSX.Element}
   */

  const renderInput = (column, autoFocus) => {
    const value = row[column.field];
    const error = errors[column.field];
    const handleFocus = (e) => {
      const input = e.target;
      const type = input.getAttribute("type");
      
      if (type !== "number")
        input.setSelectionRange(e.target.value.length, e.target.value.length);
      else{
        input.select();
      }
    }
    const handleChange = (e) => {
      let value = column.type === "bool" ?
        e.target.checked :
        e.target.value;
      if (column.type === "number") {
        if (value === "" || !value) {
          if (column.defaultInitValue)
            value = Number(column.defaultInitValue)
          else value = null;
        }
        value = Number(value);
      }
      onChange(
        row,
        column,
        value
      )
    }
    const handleKeyDown = (e)=>{
      if(e.key === "Enter")
      {
        e.preventDefault();
        onSave();
      }
      else if (e.key === "Escape")
      {
        e.preventDefault();
        onCancel();
      }
    }
    /*
     * STRING
     */
    if (column.type === "string") {
      return (
        <Form.Group>
          {/* <Form.Label>
            {column.title}

            {column.required && (
              <span className="text-danger ml-1">
                *
              </span>
            )}
          </Form.Label> */}

          <Form.Control
            type="text"
            value={
              value === null || value === undefined
                ? ""
                : value
            }
            readOnly={column.readOnly || false}
            maxLength={column.maxLength}
            onChange={handleChange}
            isInvalid={!!error}
            disabled={saving}
            autoFocus={autoFocus && extAutoFocus}
            onFocus={handleFocus}
            onKeyDown={handleKeyDown}
          />

          {error && (
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      );
    }

    /*
     * NUMBER
     */
    if (column.type === "number") {
      return (
        <Form.Group>
          {/* <Form.Label>
            {column.title}

            {column.required && (
              <span className="text-danger ml-1">
                *
              </span>
            )}
          </Form.Label> */}

          <Form.Control
            type="number"
            readOnly={column.readOnly || false}
            value={
              value === null ||
                value === undefined
                ? ""
                : value
            }
            onChange={handleChange}
            isInvalid={!!error}
            disabled={saving}
            autoFocus={autoFocus && extAutoFocus}
            onFocus={handleFocus}
            onKeyDown={handleKeyDown}
          />

          {error && (
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      );
    }

    /*
     * BOOL
     */
    if (column.type === "bool") {
      return (
        <Form.Group>
          <Form.Check
            type="checkbox"
            //label={column.title}
            checked={value === true}
            onChange={handleChange}
            disabled={saving}
            isInvalid={!!error}
          />

          {error && (
            <div className="invalid-feedback d-block">
              {error}
            </div>
          )}
        </Form.Group>
      );
    }

    /*
     * DROPDOWN
     */
    if (column.type === "dropdown") {
      const dataSource = Array.isArray(
        column.dataSource
      )
        ? column.dataSource
        : [];

      /*
       * Verify selected item.
       */
      findDropdownItem(
        dataSource,
        column,
        value
      );

      return (
        <Form.Group>
          {/* <Form.Label>
            {column.title}

            {column.required && (
              <span className="text-danger ml-1">
                *
              </span>
            )}
          </Form.Label> */}

          <select className="form-control"
            value={
              value === null ||
                value === undefined
                ? ""
                : String(value)
            }
            onChange={e => {
              const selectedValue =
                e.target.value;

              /*
               * Empty option => null
               */
              if (selectedValue === "") {
                onChange(
                  column.field,
                  null
                );
                return;
              }

              /*
               * Find original object so the
               * original value type is preserved.
               *
               * 2 remains Number 2
               * instead of becoming "2".
               */
              const selectedItem =
                dataSource.find(item => {
                  return (
                    item &&
                    String(
                      item[column.valueField]
                    ) === selectedValue
                  );
                });

              if (selectedItem) {
                onChange(
                  column.field,
                  selectedItem[
                  column.valueField
                  ]
                );
              }
            }}
            isInvalid={!!error}
            disabled={saving}
          >
            {column.placeholder && (
              <option value="">
                {column.placeholder}
              </option>
            )}

            {!column.placeholder && (
              <option value="">
                انتخاب کنید...
              </option>
            )}

            {dataSource.map(item => {
              const itemValue =
                item[column.valueField];

              const itemText =
                item[column.textField];

              return (
                <option
                  key={String(itemValue)}
                  value={String(itemValue)}
                >
                  {itemText}
                </option>
              );
            })}
          </select>

          {error && (
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      );
    }

    return null;
  };
  const firstStringIndex = columns.findIndex(
    column => column.type !== "bool" && !column.readOnly && !column.hideInEditMode
  );
  return (

    <div className="datatable-edit-form">
      {columns.map((column, index) => {
        const autoF = index === firstStringIndex;
        console.log(
          "MAP:",
          index,
          column.field,
          column.type
        );
        return (
          <div key={column.field}>
            {renderInput(column, autoF)}
          </div>
        )
      })}

      {showButtons && (
        <div className="datatable-edit-buttons">
          <Button
            variant="success"
            size="sm"
            onClick={onSave}
            disabled={saving}
          >
            {saving && (
              <Spinner
                animation="border"
                size="sm"
                className="mr-1"
              />
            )}

            <CheckLg size={16} />
          </Button>

          <Button
            variant="secondary"
            size="sm"
            onClick={onCancel}
            disabled={saving}
            className="ml-2"
          >
            انصراف
          </Button>
        </div>
      )}
    </div>
  );
}

export default DataTableEditForm;